import { render, staticRenderFns } from "./BlogsCategoriesComponent.vue?vue&type=template&id=8aadc840&scoped=true"
import script from "./BlogsCategoriesComponent.vue?vue&type=script&lang=js"
export * from "./BlogsCategoriesComponent.vue?vue&type=script&lang=js"
import style0 from "./BlogsCategoriesComponent.vue?vue&type=style&index=0&id=8aadc840&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aadc840",
  null
  
)

export default component.exports